import { gql } from "@apollo/client"

const REMOVE_GUARDIAN_FROM_EVENT_MUTATION = gql`
  mutation($input: ExcludeGuardianInput!) {
    excludeGuardian(input: $input)
  }
`

export { REMOVE_GUARDIAN_FROM_EVENT_MUTATION }